import { defineFurniture } from './types.js';

/**
 * Blindbox prizes. They are never sold in a shop (`price` is zero and there is
 * no `premium`): the only way to get a new one is to open a blindbox (see
 * blindbox.ts). Players can still trade and resell them.
 */
export const PRIZE_FURNITURE = defineFurniture('rare', {
  prize_lantern: {
    label: 'Festive Lantern',
    description: 'A red lantern with gold caps. Lucky!',
    price: 0,
    solid: true,
    height: 0.9,
  },
  prize_plush_bear: {
    label: 'Giant Plush Bear',
    description: 'Won at the pasar malam. Very huggable.',
    price: 0,
    solid: true,
    height: 0.9,
  },
  prize_neon_sign: {
    label: 'Neon Kopi Sign',
    description: 'Glows all night, like the best kopitiams.',
    price: 0,
    solid: true,
    height: 1.4,
    effect: { type: 'glow', color: '#ff5fa2', height: 38 },
  },
  prize_lava_lamp: {
    label: 'Lava Lamp',
    description: 'Slow, sleepy blobs of colour.',
    price: 0,
    solid: true,
    height: 0.9,
    effect: { type: 'glow', color: '#ff8a3d', height: 30 },
  },
  prize_trophy: {
    label: 'Champion Trophy',
    description: 'For the undisputed champion of the kopitiam.',
    price: 0,
    solid: true,
    height: 1.1,
    effect: { type: 'sparkle', color: '#ffe27a', height: 36 },
  },
  prize_crystal_ball: {
    label: 'Crystal Ball',
    description: 'It says you will have a good day.',
    price: 0,
    solid: true,
    height: 0.9,
    effect: { type: 'sparkle', color: '#c9a8ff', color2: '#ffffff', height: 30 },
  },
  prize_phoenix: {
    label: 'Phoenix Statue',
    description: 'A fiery bird that never stops burning.',
    price: 0,
    solid: true,
    height: 1.6,
    effect: { type: 'flames', color: '#ff7a1a', color2: '#ffe27a', height: 46 },
  },
  prize_rainbow_fountain: {
    label: 'Rainbow Fountain',
    description: 'Every colour of the rainbow, in water.',
    price: 0,
    solid: true,
    height: 1.3,
    effect: { type: 'spray', color: '#ff7ab8', color2: '#7fe0ff', height: 44 },
  },
});
